import { render, staticRenderFns } from "./ModalLg.vue?vue&type=template&id=6c0be2b7&"
import script from "./ModalLg.vue?vue&type=script&lang=js&"
export * from "./ModalLg.vue?vue&type=script&lang=js&"
import style0 from "./ModalLg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports